module.exports = __webpack_public_path__ + "static/media/healtcare.4132bfb6.svg";